import { useState } from 'react';
import { Link, Outlet, useLocation, useParams } from 'react-router-dom';

// material-ui
import { Box, Stack, Tab, Tabs } from '@mui/material';

// project-imports
import MainCard from 'components/MainCard';
import BackButton from 'components/BackButton';
import { useHeaderActionSlot } from 'contexts/HeaderActionContext';

// assets
import { DocumentText, Lock, Setting2 } from 'iconsax-react';

// ==============================|| PROFILE - ACCOUNT ||============================== //

const AccountProfile = () => {
  const { pathname } = useLocation();

  const { id } = useParams();

  let selectedTab = 0;
  switch (pathname) {
    case `/users/list/${id}/personal`:
      selectedTab = 0;
      break;
    case `/users/list/${id}/advanced`:
      selectedTab = 1;
      break;
    case `/users/list/${id}/password`:
      selectedTab = 2;
      break;
    default:
      selectedTab = 0;
  }

  const [value, setValue] = useState(selectedTab);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useHeaderActionSlot(<BackButton to="/users/list" label="Back to users" />);

  return (
    <Stack spacing={2}>
      <MainCard border={false}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="account profile tab"
        >
          <Tab
            label="User Information"
            component={Link}
            to={`/users/list/${id}/personal`}
            icon={<DocumentText />}
            iconPosition="start"
          />
          <Tab
            label="Advanced Features"
            component={Link}
            to={`/users/list/${id}/advanced`}
            icon={<Setting2 />}
            iconPosition="start"
          />
          {/* <Tab
            label="Profile"
            component={Link}
            to={`/users/list/${id}/basic`}
            icon={<Profile />}
            iconPosition="start"
          /> */}
          {/* <Tab
            label="My Account"
            component={Link}
            to={`/users/list/${id}/my-account`}
            icon={<TableDocument />}
            iconPosition="start"
          /> */}
          <Tab
            label="Change Password"
            component={Link}
            to={`/users/list/${id}/password`}
            icon={<Lock />}
            iconPosition="start"
          />
        </Tabs>
      </Box>
      <Box sx={{ mt: 2.5 }}>
        <Outlet />
      </Box>
      </MainCard>
    </Stack>
  );
};

export default AccountProfile;
